import { AjaxService } from "../shared/services/AjaxService";
import { ResponseModel } from "../models/ResponseModel";

/* ================= DTO ================= */

export interface GetSringarsDto {
  date: string; // yyyy-MM-dd
}

export interface SringarDto {
  sringarId?: string | null;
  userId?: string | null;
  date: string; // yyyy-MM-dd
  isGuruPuja: boolean;
  marks: number;
}

export interface SringarFilterDto {
  userId?: string | null;
  fromDate: string; // yyyy-MM-dd
  toDate: string; // yyyy-MM-dd
}

/* ================= SERVICE ================= */

export const SringarService = {
  // 🔹 Get entry for selected date (POST)
  async getAgainstDate(date: string): Promise<ResponseModel> {
    return AjaxService.post<ResponseModel>("/Sringar/getSringarAgainstDate", { date });
  },

  // 🔹 Create (POST)
  async create(payload: SringarDto): Promise<ResponseModel> {
    return AjaxService.post<ResponseModel>("/Sringar/create", payload);
  },

  // 🔹 Update (PUT)
  async update(payload: SringarDto): Promise<ResponseModel> {
    return AjaxService.put<ResponseModel>("/Sringar/update", payload);
  },

  // 🔹 History (POST)
  async history(payload: SringarFilterDto): Promise<ResponseModel> {
    return AjaxService.post<ResponseModel>("/Sringar/getSringarHistory", payload);
  },

  // 🔹 Get single (GET)
  async get(sringarId: string): Promise<ResponseModel> {
    return AjaxService.get<ResponseModel>(
      `/Sringar/getSringar?sringarId=${encodeURIComponent(sringarId)}`
    );
  },

  // 🔹 Delete (DELETE)
  async delete(sringarId: string): Promise<ResponseModel> {
    return AjaxService.delete<ResponseModel>(
      `/Sringar/delete?sringarId=${encodeURIComponent(sringarId)}`
    );
  },
};